// extracted by mini-css-extract-plugin
module.exports = {"button":"_2d03a26"};